// root '../../../';
import React from 'react';
import ReactDOM from 'react-dom';
import { Child } from 'pym.js';
import Zion from './utils/Zion';
import App from './App';

// dependencies

// styles
import './styles/index.scss';

const pkg = require('../package.json');

// eslint-disable-next-line  no-use-before-define
window.pymChild = new Child({ renderCallback: draw });

window.onload = () => {
  // necessary evil for right now

  const { pymChild } = window;
  pymChild.sendHeight();

  if (pymChild.parentUrl) {
    const zion = new Zion(pkg.name, pymChild.parentUrl);
  }
};

ReactDOM.render(
  <App />,

  document.getElementById('root'),
);

function draw(initialWidth) {
  // console.log('triggering draw function');
}
